import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { AquacomComponentType, MooringArticleType, MooringArticleTypeVariant } from 'models/mooring';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class MooringArticleTypeService extends BaseApiService<MooringArticleType> {
  constructor(httpClient: AuthHttpClient, private client: NetlogHttpClient) {
    super(httpClient, MooringArticleType);
  }

  async getAquacomTypes(aquacomCategoryId: number) {
    return (
      await this.client.get<AquacomComponentType[]>({
        url: `${MooringArticleType.ApiUrl}/aquacom/${aquacomCategoryId}`,
        model: AquacomComponentType,
      })
    ).data;
  }

  async getVariants() {
    return (
      await this.client.get<MooringArticleTypeVariant[]>({
        url: `${MooringArticleType.ApiUrl}/variants`,
        model: MooringArticleTypeVariant,
      })
    ).data;
  }
}
